import ConciergePage from './Concierge';

export const Concierge = () => <ConciergePage />;
